(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["before-after-slider"] && !Shopify.designMode) return;
  try {
    (function () {
    function init(el) {
      var range = el.querySelector('[data-ba-range]');
      if (!range) return;
      var update = function () { el.style.setProperty('--split', range.value + '%'); };
      range.addEventListener('input', update);
      update();
    }
    function initAll() {
      var nodes = document.querySelectorAll('[data-ba-slider]');
      for (var i = 0; i < nodes.length; i++) init(nodes[i]);
    }
    if (document.readyState !== 'loading') initAll();
    else document.addEventListener('DOMContentLoaded', initAll);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["carousel"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.carousel:not([data-initialized])').forEach(function (root) {
      root.setAttribute('data-initialized', 'true');

      var track = root.querySelector('.carousel__track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.children);
      if (slides.length === 0) return;

      var dots = root.querySelectorAll('.carousel__dot');
      var prevBtn = root.querySelector('.carousel__arrow--prev');
      var nextBtn = root.querySelector('.carousel__arrow--next');
      var active = 0;

      slides.forEach(function (s, i) {
        s.setAttribute('data-active', i === 0 ? 'true' : 'false');
        s.setAttribute('aria-hidden', i === 0 ? 'false' : 'true');
      });

      function go(index) {
        var next = ((index % slides.length) + slides.length) % slides.length;
        slides[active].setAttribute('data-active', 'false');
        slides[active].setAttribute('aria-hidden', 'true');
        slides[next].setAttribute('data-active', 'true');
        slides[next].setAttribute('aria-hidden', 'false');
        if (dots.length) {
          if (dots[active]) dots[active].setAttribute('aria-selected', 'false');
          if (dots[next]) dots[next].setAttribute('aria-selected', 'true');
        }
        active = next;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () { go(active - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { go(active + 1); });

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var idx = parseInt(dot.getAttribute('data-slide-index'), 10);
          if (!isNaN(idx)) go(idx);
        });
      });

      root.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowLeft') go(active - 1);
        if (e.key === 'ArrowRight') go(active + 1);
      });

      var touchStartX = 0;
      var touchStartY = 0;
      var touchTracking = false;
      track.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 1) return;
        touchStartX = e.touches[0].clientX;
        touchStartY = e.touches[0].clientY;
        touchTracking = true;
      }, { passive: true });
      track.addEventListener('touchend', function (e) {
        if (!touchTracking) return;
        touchTracking = false;
        var touch = e.changedTouches[0];
        var dx = touch.clientX - touchStartX;
        var dy = touch.clientY - touchStartY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          if (dx < 0) go(active + 1);
          else go(active - 1);
        }
      });
      track.addEventListener('touchcancel', function () {
        touchTracking = false;
      });

      var autoplayMs = parseInt(root.getAttribute('data-autoplay'), 10) || 0;
      if (autoplayMs > 0 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        var timer = setInterval(function () { go(active + 1); }, autoplayMs);
        root.addEventListener('mouseenter', function () { clearInterval(timer); });
        root.addEventListener('mouseleave', function () {
          timer = setInterval(function () { go(active + 1); }, autoplayMs);
        });
      }
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('[data-quick-add]:not([data-init])').forEach(function (btn) {
      btn.setAttribute('data-init', 'true');

      function showError(msg) {
        var el = btn.parentElement.querySelector('[data-quick-add-error]');
        if (!el) return;
        el.textContent = msg;
        el.removeAttribute('hidden');
        setTimeout(function () {
          el.setAttribute('hidden', '');
          el.textContent = '';
        }, 4000);
      }

      btn.addEventListener('click', function () {
        var hasVariants = btn.getAttribute('data-has-variants') === 'true';
        var productUrl = btn.getAttribute('data-product-url');
        var variantId = parseInt(btn.getAttribute('data-variant-id'), 10);

        if (hasVariants) {
          if (productUrl) window.location.href = productUrl;
          return;
        }
        if (!variantId) {
          if (productUrl) window.location.href = productUrl;
          return;
        }

        var originalLabel = btn.textContent;
        btn.disabled = true;
        btn.textContent = '…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
        })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            btn.disabled = false;
            btn.textContent = originalLabel;
            if (data.status) {
              showError(data.description || data.message || 'Could not add to cart.');
              return;
            }
            document.dispatchEvent(new CustomEvent('bfoure:cart:changed'));
            document.dispatchEvent(new CustomEvent('bfoure:cart:open'));
          })
          .catch(function () {
            btn.disabled = false;
            btn.textContent = originalLabel;
            if (productUrl) window.location.href = productUrl;
          });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
